import React from 'react';
import { Modal, DatePicker, Button } from 'antd';
import { useTriggerDagDialog } from './use-trigger-dag-dialog';

type TriggerDagDialogProps = {
    dagId: string;
    onClose: () => void;
};

/*
 * Confirms and submits a manual trigger of a DAG run with a Logical Date (UTC) field
 */
export function TriggerDagDialog({ dagId, onClose }: TriggerDagDialogProps) {
    const { logicalDate, setLogicalDate, isSubmitting, handleSubmit } = useTriggerDagDialog(dagId, onClose);

    return (
        <Modal
            visible
            className="airflowDashboardRoot"
            title="Trigger DAG"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="trigger" type="primary" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Triggering…' : 'Trigger'}
                </Button>,
            ]}
        >
            <div style={{ marginBottom: 12, fontSize: 12, color: '#e1e1e6' }}>{`Are you sure you want to trigger ${dagId}?`}</div>
            <div>
                <div style={{ marginBottom: 6, color: '#666a8d', fontSize: 12 }}>Logical Date (UTC)</div>
                <DatePicker
                    showTime
                    value={logicalDate}
                    onChange={setLogicalDate}
                    style={{ width: '100%' }}
                    dropdownClassName="airflowDashboardRoot"
                />
            </div>
        </Modal>
    );
}
